import { constantRoutes, asyncRoutes } from '@/router'
import { getUserInfo, checkWp } from '@/resource/api'
import { constantTab } from '@/settings'

const router = {
  state: {
    userType: '',
    userInfo: {},
    hasUserInfo: false,
    asyncRoutes: [],
    menuList: [],
    tabList: [],
    breadCrumbList: [...constantTab],
    businessAccount: '',
    createBy: '', // cp、ugc传不带邮箱后缀
    createBySuffix: '', // vod传带邮箱后缀
    updateBy: '', // cp、ugc传不带邮箱后缀
    updateBySuffix: '', // vod传带邮箱后缀
    cpcode: '',
    companyName: '',
    companyId: '',
    services: [],
    anchorId: ''
  },
  mutations: {
    SET_ROUTES (state, data) {
      state.asyncRoutes = constantRoutes.concat(data)
    },
    SET_USER_TYPE (state, data) {
      state.userType = data
    },
    SET_ANCHOR_ID (state, data) {
      state.anchorId = data.anchorId
    },
    SET_MENU (state, data) {
      state.menuList = data
    },
    SET_TABS (state, data) {
      state.tabList = data
    },
    REMOVE_TAB (state, index) {
      state.tabList.splice(index, 1)
    },
    SET_BREAD_CRUMB (state, data) {
      state.breadCrumbList = data
    },
    SET_USERINFO (state, data) {
      state.userInfo = data
    },
    SET_CPCODE (state, data) {
      state.cpcode = data.companyCode
    },
    SET_COMPANYNAME (state, data) {
      state.companyName = data.companyName
    },
    SET_SERVICES (state, data) {
      const filterArr = []
      data.services.forEach(item => {
        // 三个平台都有权限或只有vod权限 概览选择展示
        if (item.key == 'APPPACK' || item.key == 'VOD' || item.key == 'CMS') {
          filterArr.push(item.key)
        }
      })
      state.services = filterArr
    },
    SET_COMPANYID (state, data) {
      state.companyId = data.companyId
    },
    CHANGE_USER_STATE (state, flag) {
      state.hasUserInfo = flag
    },
    SET_BUSINESS_ACCOUNT (state, data) {
      state.businessAccount = data.userId
      state.createBySuffix = data.userName
      if (data.userName.indexOf('@') != -1) {
        state.createBy = data.userName.match(/^.*(?=(@))/g)[0]
      } else {
        state.createBy = data.userName
      }
    },
    SET_UPDATEBY (state, data) {
      state.createBySuffix = data.username
      state.updateBySuffix = data.username
      if (data.username.indexOf('@') != -1) {
        state.updateBy = data.username.match(/^.*(?=(@))/g)[0]
        state.createBy = data.username.match(/^.*(?=(@))/g)[0]
      } else {
        state.createBy = data.username
        state.updateBy = data.username
      }
    }
  },
  actions: {
    getUserInfo ({ dispatch, commit, state }) {
      return new Promise((resolve, reject) => {
        if (process.env.VUE_APP_NODE_ENV == 'CP') {
          Promise.all([getUserInfo(), checkWp()]).then(res => {
            const { data, errorCode } = res[0]
            if (errorCode == 0) {
              commit('SET_USERINFO', data)
              commit('SET_UPDATEBY', data)
              commit('SET_CPCODE', data)
              commit('SET_COMPANYNAME', data)
              commit('SET_SERVICES', data)
              commit('SET_COMPANYID', data)
              commit('CHANGE_USER_STATE', true)
              commit('SET_ANCHOR_ID', data)
              resolve()
            } else {
              commit('CHANGE_USER_STATE', false)
              reject(res[0].errorMessage)
            }
          }).catch(e => {
            reject(e)
          })
        } else {
          getUserInfo().then(res => {
            const { data, errorCode } = res
            if (errorCode == 0) {
              commit('SET_USERINFO', data)
              commit('SET_UPDATEBY', data)
              commit('SET_CPCODE', data)
              commit('SET_COMPANYNAME', data)
              commit('SET_SERVICES', data)
              commit('SET_COMPANYID', data)
              commit('CHANGE_USER_STATE', true)
              commit('SET_ANCHOR_ID', data)
              resolve()
            } else {
              commit('CHANGE_USER_STATE', false)
              reject(res)
            }
          }).catch(e => {
            reject(e)
          })
        }
      })
    },
    GenerateRoutes ({ dispatch, commit, state }) {
      // 判断角色 获取route
      const roleType = (state.userInfo.roles || []).filter(item => item.key == 'ROLE_ADMIN').length ? 'admin' : 'user'
      const routes = asyncRoutes
      console.log(routes)
      commit('SET_ROUTES', routes)
      const LayoutList = state.asyncRoutes.filter(item => item.name === 'Layout').map(item => item.children).flat(1)
      const comenList = state.asyncRoutes.filter(item => item.name !== 'Layout')
      commit('SET_MENU', LayoutList.concat(comenList))
      commit('SET_USER_TYPE', roleType)
    },
    SetTabs ({ dispatch, commit, state }, data) {
      // 判断当前路由是否为面包屑导航
      if (data.meta.breadCrumb) {
        if (!state.breadCrumbList.some(item => item.path === data.path)) {
          commit('SET_BREAD_CRUMB', [state.breadCrumbList[0], {
            path: data.path,
            name: data.meta.title
          }])
        }
        return false
      }

      // 设置首次一级导航当前导航
      commit('SET_BREAD_CRUMB', [{
        path: data.path,
        name: data.meta.title
      }])

      // 设置tab导航数据
      if (!state.tabList.some(item => item.path === data.path)) {
        commit('SET_TABS', [...state.tabList, {
          path: data.path,
          name: data.meta.title
        }])
      }
    },
    RemoveTab ({ dispatch, commit, state }, data) {
      for (let i = 0; i < state.tabList.length; i++) {
        if (state.tabList[i].path === data) {
          commit('REMOVE_TAB', i)
          break
        }
      }
    },
    setBusinessAccount ({ dispatch, commit, state }, data) {
      commit('SET_BUSINESS_ACCOUNT', data)
    }
  }
}

export default router
